/* loonara storefront JS · vanilla, no jQuery. Header/menu/search/cart drawer, carousels, product form, sticky ATC, filters. */
(function () {
  'use strict';
  var d = document, w = window;
  var money = function (cents) {
    var fmt = (d.body.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €');
    var n = (cents / 100);
    var s = n.toFixed(2);
    if (fmt.indexOf('comma_separator') > -1) s = s.replace('.', ',');
    if (fmt.indexOf('no_decimals') > -1) s = Math.round(n).toString();
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s);
  };
  var lnEta = function (minD, maxD) {
    var add = function (n) { var dt = new Date(), c = 0; while (c < n) { dt.setDate(dt.getDate() + 1); var wd = dt.getDay(); if (wd !== 0 && wd !== 6) c++; } return dt; };
    var f = function (dt) { return dt.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'numeric' }).replace(/\.$/, ''); };
    return 'Lieferung ca. ' + f(add(minD)) + ' – ' + f(add(maxD));
  };
  var qs = function (s, r) { return (r || d).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var lock = function (on) { d.body.classList.toggle('ln-lock', !!on); };

  /* ---------- Offcanvas ---------- */
  var scrim = qs('[data-ln-scrim]');
  var openOff = null;
  function closeAll() {
    qsa('.ln-off.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    qsa('.ln-sub.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    if (scrim) scrim.classList.remove('is-open');
    var h = qs('.ln-header'); if (h) h.classList.remove('is-open');
    lock(false); openOff = null;
  }
  function openPanel(id) {
    var el = d.getElementById(id); if (!el) return;
    closeAll();
    el.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); lock(true); openOff = el;
    qsa('img[data-ln-src]', el).forEach(function (im) { im.src = im.getAttribute('data-ln-src'); im.removeAttribute('data-ln-src'); });
    var h = qs('.ln-header'); if (h) h.classList.add('is-open');
    var f = qs('input,button,a', el); if (f && w.innerWidth < 992) setTimeout(function () { try { f.focus(); } catch (e) {} }, 50);
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ln-open]');
    if (t) { e.preventDefault(); openPanel(t.getAttribute('data-ln-open')); return; }
    if (e.target.closest('[data-ln-close]') || e.target === scrim) { e.preventDefault(); closeAll(); return; }
    var s = e.target.closest('[data-ln-sub]');
    if (s) {
      e.preventDefault();
      var id = s.getAttribute('data-ln-sub');
      qsa('.ln-sub.is-open').forEach(function (el) { if (el.id !== id) el.classList.remove('is-open'); });
      var sub = d.getElementById(id); if (sub) sub.classList.add('is-open');
      qsa('[data-ln-sub]').forEach(function (b) { b.classList.toggle('is-active', b === s); });
      return;
    }
    var back = e.target.closest('[data-ln-subclose]');
    if (back) { e.preventDefault(); var p = back.closest('.ln-sub'); if (p) p.classList.remove('is-open'); return; }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); var sb = qs('.ln-search.is-open'); if (sb) sb.classList.remove('is-open'); } });
  /* Desktop: hover opens submenu */
  if (w.matchMedia('(min-width: 992px)').matches) {
    qsa('[data-ln-sub]').forEach(function (b) {
      b.addEventListener('mouseenter', function () { b.click(); });
    });
  }

  /* ---------- Farbschema-Schalter ---------- */
  var syncTheme = function () { var pref = d.documentElement.getAttribute('data-theme-pref') || 'auto'; qsa('[data-ln-theme-set]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ln-theme-set') === pref ? 'true' : 'false'); }); };
  syncTheme();
  d.addEventListener('click', function (e) { var b = e.target.closest('[data-ln-theme-set]'); if (!b || !w.lnTheme) return; w.lnTheme.set(b.getAttribute('data-ln-theme-set')); syncTheme(); });
  d.addEventListener('click', function (e) { var t = e.target.closest('[data-ln-theme-toggle]'); if (!t || !w.lnTheme) return; var dark = d.documentElement.getAttribute('data-theme') === 'dark'; w.lnTheme.set(dark ? 'light' : 'dark'); syncTheme(); });
  /* ---------- Header scroll state + search ---------- */
  var header = qs('.ln-header');
  if (header) {
    var isHome = d.body.classList.contains('ln-home'), lastY = w.scrollY;
    var ann = qs('.ln-ann');
    var setAnn = function () { d.documentElement.style.setProperty('--ann-real', (ann ? ann.getBoundingClientRect().height : 0) + 'px'); };
    setAnn(); w.addEventListener('resize', setAnn);
    var onScroll = function () {
      var y = w.scrollY, dy = y - lastY; lastY = y;
      header.classList.toggle('is-scrolled', y > 24);
      if (header.classList.contains('is-open')) return;
      var past = y > header.offsetHeight + 120;
      if (isHome) {
        header.classList.toggle('is-float', past);
        if (!past) header.classList.remove('is-pinned');
        else if (dy < -3) header.classList.add('is-pinned');
        else if (dy > 3) header.classList.remove('is-pinned');
      } else {
        if (!past) header.classList.remove('is-hidden');
        else if (dy > 3) header.classList.add('is-hidden');
        else if (dy < -3) header.classList.remove('is-hidden');
      }
    };
    onScroll(); w.addEventListener('scroll', onScroll, { passive: true });
  }
  var searchBar = qs('[data-ln-search]');
  qsa('[data-ln-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); if (!searchBar) return;
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) { var i = qs('input', searchBar); if (i) i.focus(); }
    });
  });

  /* ---------- Cart ---------- */
  var lastCart = null;
  var cart = {
    fetch: function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    add: function (id, qty, props) {
      var body = { items: [{ id: id, quantity: qty || 1 }] };
      if (props) body.items[0].properties = props;
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    },
    render: function (c) {
      lastCart = c;
      var wrap = qs('[data-ln-cart-lines]'); if (!wrap) return;
      var ttl = qs('#ln-cart .ln-off__title');
      if (ttl) ttl.textContent = c.item_count ? 'Warenkorb · ' + c.item_count + ' Artikel' : 'Warenkorb';
      var count = qs('[data-ln-cart-count]');
      if (count) { count.textContent = c.item_count; count.classList.toggle('has-items', c.item_count > 0); }
      var total = qs('[data-ln-cart-total]'); if (total) total.textContent = money(c.total_price);
      var free = parseInt((qs('[data-ln-free-threshold]') || {}).getAttribute ? qs('[data-ln-free-threshold]').getAttribute('data-ln-free-threshold') : 0, 10) || 0;
      var ship = qs('[data-ln-cart-ship]');
      if (ship && free) {
        var left = free - c.total_price;
        ship.innerHTML = left > 0 ? ('Noch <strong>' + money(left) + '</strong> bis zum kostenlosen Versand (DE).') : '<strong>Kostenloser Versand</strong> innerhalb Deutschlands.';
        var bar = qs('[data-ln-cart-bar]'); if (bar) bar.style.width = Math.min(100, Math.round(c.total_price / free * 100)) + '%';
      }
      /* Upsells: verstecken, was schon im Warenkorb liegt */
      var up = qs('[data-ln-upsell]'); if (up) { var ids = c.items.map(function (i) { return String(i.product_id); }); var vis = 0; qsa('[data-product-id]', up).forEach(function (card) { var h = ids.indexOf(card.getAttribute('data-product-id')) > -1; card.hidden = h; if (!h) vis++; }); up.hidden = !(c.items.length && vis); }
      var drawer = qs('#ln-cart'), empty = qs('[data-ln-cart-emptystate]'), foot = qs('[data-ln-cart-foot]');
      if (empty) empty.hidden = !!c.items.length;
      if (foot) foot.hidden = !c.items.length;
      var shipEl = qs('[data-ln-cart-shipcost]'), eta = qs('[data-ln-cart-eta]');
      if (drawer && shipEl) { var shipC = parseInt(drawer.getAttribute('data-ln-ship-cost') || '390', 10); var isFree = free && c.total_price >= free; shipEl.innerHTML = isFree ? '<strong style="color:var(--success)">Kostenlos</strong>' : money(shipC) + ' <span class="ln-muted">(DE)</span>'; }
      if (drawer && eta) { eta.textContent = c.items.length ? lnEta(parseInt(drawer.getAttribute('data-ln-eta-min') || '2', 10), parseInt(drawer.getAttribute('data-ln-eta-max') || '4', 10)) + ' · inkl. MwSt.' : ''; }
      if (!c.items.length) { wrap.innerHTML = ''; wrap.removeAttribute('data-keys'); return; }
      var keys = c.items.map(function (i) { return i.key; }).join('|');
      if (wrap.getAttribute('data-keys') === keys) {
        /* Gleiche Zeilen: nur Zahlen nachziehen. Kein innerHTML-Neubau -> kein Flackern, kein Fokusverlust. */
        var lines = qsa('.ln-cart__line', wrap);
        c.items.forEach(function (it, i) {
          var line = lines[i]; if (!line) return;
          line.hidden = false; line.classList.remove('is-busy');
          var inp = qs('.ln-qty input', line);
          if (inp && d.activeElement !== inp) inp.value = it.quantity;
          var pr = qs('.ln-cart__line-row strong', line);
          if (pr) pr.textContent = money(it.final_line_price);
        });
        return;
      }
      wrap.setAttribute('data-keys', keys);
      wrap.innerHTML = c.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2') : '';
        return '<div class="ln-cart__line" data-key="' + it.key + '">' +
          '<a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="88" height="88">' : '') + '</a>' +
          '<div><div class="ln-cart__line-title">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ln-cart__line-meta">' + it.variant_title + '</div>' : '') +
          (function () { var m = /(\d+)\s*(-teilig|Beutel)/.exec(it.variant_title || ''); if (!m) return ''; var n = parseInt(m[1], 10); if (!(n > 1)) return ''; return '<div class="ln-cart__line-unit">nur ' + money(Math.round(it.final_price / n)) + ' je ' + (m[2] === 'Beutel' ? 'Beutel' : 'Teil') + '</div>'; })() +
          '<div class="ln-cart__line-row"><div class="ln-qty"><button type="button" data-ln-qty="-1" aria-label="Weniger">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Menge"><button type="button" data-ln-qty="1" aria-label="Mehr">+</button></div>' +
          '<div><strong>' + money(it.final_line_price) + '</strong></div></div>' +
          '<button type="button" class="ln-cart__remove" data-ln-remove>Entfernen</button></div></div>';
      }).join('');
    },
    refresh: function () { return cart.fetch().then(cart.render); },
    open: function () { openPanel('ln-cart'); }
  };
  w.lnCart = cart;

  /* Mengenaenderung: Anzeige sofort, Server zeitversetzt. Mehrfachklicks werden gebuendelt. */
  var pending = {}, flushT = null, busy = false;
  function paintTotals() {
    if (!lastCart) return;
    var sum = 0, cnt = 0;
    lastCart.items.forEach(function (x) {
      var q = pending.hasOwnProperty(x.key) ? pending[x.key] : x.quantity;
      sum += x.final_price * q; cnt += q;
    });
    var tot = qs('[data-ln-cart-total]'); if (tot) tot.textContent = money(sum);
    var badge = qs('[data-ln-cart-count]'); if (badge) { badge.textContent = cnt; badge.classList.toggle('has-items', cnt > 0); }
    var ttl = qs('#ln-cart .ln-off__title'); if (ttl) ttl.textContent = cnt ? 'Warenkorb · ' + cnt + ' Artikel' : 'Warenkorb';
  }
  function queue(key, qty, line) {
    pending[key] = qty;
    if (line) {
      if (qty <= 0) { line.hidden = true; }
      else {
        var inp = qs('.ln-qty input', line); if (inp && d.activeElement !== inp) inp.value = qty;
        var it = lastCart && lastCart.items.filter(function (x) { return x.key === key; })[0];
        var pr = qs('.ln-cart__line-row strong', line);
        if (it && pr) pr.textContent = money(it.final_price * qty);
      }
      line.classList.add('is-busy');
    }
    paintTotals();
    clearTimeout(flushT); flushT = setTimeout(flush, 180);
  }
  function flush() {
    if (busy) { clearTimeout(flushT); flushT = setTimeout(flush, 100); return; }
    var ks = Object.keys(pending); if (!ks.length) return;
    var k = ks[0], q = pending[k]; delete pending[k];
    busy = true;
    cart.change(k, q).then(function (c) {
      busy = false;
      if (Object.keys(pending).length) { lastCart = c; flush(); } else { cart.render(c); }
    }).catch(function () { busy = false; pending = {}; cart.refresh(); });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ln-qty]'); var line = e.target.closest('.ln-cart__line');
    if (b && line) {
      var inp = qs('input', line); var q = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-ln-qty'), 10));
      queue(line.getAttribute('data-key'), q, line); return;
    }
    if (e.target.closest('[data-ln-remove]') && line) { queue(line.getAttribute('data-key'), 0, line); }
  });
  d.addEventListener('change', function (e) {
    var line = e.target.closest('.ln-cart__line'); if (line && e.target.matches('input[type=number]')) { queue(line.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0), line); }
  });
  d.addEventListener('click', function (e) {
    var u = e.target.closest('[data-ln-upsell-add]'); if (!u) return;
    u.disabled = true; var t = u.textContent; u.textContent = '…';
    cart.add(parseInt(u.getAttribute('data-ln-upsell-add'), 10), 1).then(function () { return cart.refresh(); }).then(function () { u.disabled = false; u.textContent = t; }).catch(function (err) { u.disabled = false; u.textContent = t; alert(err.message || 'Konnte nicht hinzugefügt werden.'); });
  });
  if (qs('[data-ln-cart-lines]')) cart.refresh();

  /* ---------- Karten-Swatches: Bild + Link wechseln ---------- */
  d.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-ln-card-swatch]'); if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    var card = sw.closest('[data-ln-card]'); if (!card) return;
    qsa('[data-ln-card-swatch]', card).forEach(function (x) { x.classList.toggle('is-active', x === sw); });
    var url = sw.getAttribute('data-url');
    if (url) qsa('a', card).forEach(function (a) { if (a.closest('.ln-card__swatches')) return; a.setAttribute('href', url); });
    var img = qs('img.is-main', card), src = sw.getAttribute('data-src');
    if (img && src && img.getAttribute('src') !== src) {
      img.classList.add('is-swapping');
      var pre = new Image(); pre.onload = function () { img.src = src; if (sw.getAttribute('data-srcset')) img.srcset = sw.getAttribute('data-srcset'); img.classList.remove('is-swapping'); }; pre.onerror = function () { img.classList.remove('is-swapping'); }; pre.src = src;
      card.classList.add('is-swapped');
    }
  });
  /* ---------- Carousels ---------- */
  qsa('[data-ln-carousel]').forEach(function (c) {
    var track = qs('.ln-carousel__track', c); if (!track) return;
    var prev = qs('.ln-carousel__nav--prev', c), next = qs('.ln-carousel__nav--next', c), bar = qs('.ln-carousel__bar span', c);
    var step = function () { var f = track.firstElementChild; return f ? f.getBoundingClientRect().width + 16 : 300; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) { var frac = track.clientWidth / track.scrollWidth; bar.style.width = (frac * 100) + '%'; bar.style.left = (max ? (track.scrollLeft / max) * (100 - frac * 100) : 0) + '%'; }
    };
    track.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
  });
  /* Tabs (switch tracks) */
  qsa('[data-ln-tabs]').forEach(function (tabs) {
    qsa('[data-ln-tab]', tabs).forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-ln-tab');
        qsa('[data-ln-tab]', tabs).forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        var root = tabs.closest('[data-ln-tabs-root]') || d;
        qsa('[data-ln-panel]', root).forEach(function (p) { p.classList.toggle('ln-hidden', p.getAttribute('data-ln-panel') !== id); });
        w.dispatchEvent(new Event('resize'));
      });
    });
  });

  /* ---------- Product form ---------- */
  qsa('[data-ln-product]').forEach(function (root) {
    var dataEl = qs('[data-ln-variants]', root); if (!dataEl) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var optionCount = parseInt(root.getAttribute('data-ln-options') || '1', 10);
    var selected = [];
    var current = null;
    var form = qs('form[data-ln-form]', root);
    var idInput = qs('input[name="id"]', root);
    var priceEl = qs('[data-ln-price]', root), cmpEl = qs('[data-ln-compare]', root), tagEl = qs('[data-ln-savings]', root);
    var atc = qs('[data-ln-atc]', root), atcText = qs('[data-ln-atc-text]', root);
    var stickyPrice = qs('[data-ln-sticky-price]'), stickyAtc = qs('[data-ln-sticky-atc]');
    var gallery = qs('[data-ln-gallery]', root);
    var comingSoon = root.getAttribute('data-ln-coming-soon') === 'true';

    function init() {
      for (var i = 1; i <= optionCount; i++) {
        var act = qs('[data-ln-option="' + i + '"] .is-active', root);
        selected[i - 1] = act ? act.getAttribute('data-value') : null;
      }
      update(false);
    }
    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) { if (v.options[i] !== selected[i]) return false; }
        return true;
      });
    }
    function availabilityFor(i, value) {
      return variants.some(function (v) {
        if (v.options[i] !== value) return false;
        for (var j = 0; j < optionCount; j++) { if (j !== i && selected[j] && v.options[j] !== selected[j]) return false; }
        return v.available;
      });
    }
    function update(userAction) {
      current = findVariant();
      for (var i = 0; i < optionCount; i++) {
        qsa('[data-ln-option="' + (i + 1) + '"] [data-value]', root).forEach(function (b) {
          var v = b.getAttribute('data-value');
          b.classList.toggle('is-active', v === selected[i]);
          b.classList.toggle('is-soldout', !availabilityFor(i, v));
          b.setAttribute('aria-pressed', v === selected[i] ? 'true' : 'false');
        });
        qsa('[data-ln-option-label="' + (i + 1) + '"]', root).forEach(function (lab) { lab.textContent = selected[i] || ''; });
      }
      if (!current) { if (atc) { atc.disabled = true; if (atcText) atcText.textContent = 'Nicht verfügbar'; } return; }
      if (idInput) idInput.value = current.id;
      if (priceEl) priceEl.textContent = money(current.price);
      var p2 = qs('[data-ln-price-2]', root); if (p2 && !comingSoon) p2.textContent = money(current.price);
      if (stickyPrice) stickyPrice.textContent = money(current.price);
      if (cmpEl) { if (current.compare_at_price && current.compare_at_price > current.price) { cmpEl.textContent = money(current.compare_at_price); cmpEl.classList.remove('ln-hidden'); if (tagEl) { tagEl.textContent = '(' + Math.round((1 - current.price / current.compare_at_price) * 100) + '% Rabatt)'; tagEl.classList.remove('ln-hidden'); } } else { cmpEl.classList.add('ln-hidden'); if (tagEl) tagEl.classList.add('ln-hidden'); } }
      var av = current.available && !comingSoon;
      [atc, stickyAtc].forEach(function (b) { if (!b) return; b.disabled = !av; var t = qs('[data-ln-atc-text]', b) || b; if (comingSoon) t.textContent = 'Bald verfügbar'; else t.textContent = av ? 'In den Warenkorb' : 'Ausverkauft'; });
      if (userAction && w.history && w.history.replaceState) { var u = new URL(w.location.href); u.searchParams.set('variant', current.id); w.history.replaceState({}, '', u.toString()); }
      var fm = current.featured_media && current.featured_media.id; if (gallery && fm && userAction) { var idx = qsa('.ln-gallery__slide', gallery).filter(function (s) { return s.offsetParent !== null; }).findIndex(function (s) { return s.getAttribute('data-media-id') === String(fm); }); if (idx > -1) galleryGo(gallery, idx); }
      /* Stückpreis + Spar-Hinweis bei Sets (n-teilig / n Beutel) */
      (function () { var u = qs('[data-ln-unit]', root); if (!u) return; var t = current.title || ''; var m = /(\d+)\s*(-teilig|Beutel)/.exec(t); if (!m || parseInt(m[1], 10) < 2) { u.hidden = true; return; }
        var n = parseInt(m[1], 10), unit = Math.round(current.price / n); qs('[data-ln-unit-price]', u).textContent = money(unit); qs('[data-ln-unit-label]', u).textContent = m[2] === 'Beutel' ? 'Beutel' : 'Teil';
        var best = null; variants.forEach(function (v) { var mm = /(\d+)\s*(-teilig|Beutel)/.exec(v.title || ''); if (!mm) return; var k = parseInt(mm[1], 10); if (k > n && v.available) { var uu = v.price / k; if (uu < unit && (!best || uu < best.u)) best = { u: uu, k: k, label: mm[1] + (mm[2] === 'Beutel' ? ' Beutel' : '-teilig') }; } });
        var hint = qs('[data-ln-unit-hint]', u); hint.textContent = best ? ('· ' + best.label + ': nur ' + money(Math.round(best.u)) + ' je ' + (m[2] === 'Beutel' ? 'Beutel' : 'Teil')) : ''; u.hidden = false; })();
      var nlp = qs('[data-ln-nl-price]', root); var pct = parseInt(root.getAttribute('data-ln-nl-pct') || '0', 10); if (nlp && pct) nlp.textContent = money(Math.round(current.price * (100 - pct) / 100));
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ln-option] [data-value]'); if (!b) return;
      e.preventDefault();
      var i = parseInt(b.closest('[data-ln-option]').getAttribute('data-ln-option'), 10) - 1;
      selected[i] = b.getAttribute('data-value');
      update(true);
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); if (!current || !current.available || comingSoon) return;
      var qty = parseInt((qs('input[name="quantity"]', form) || { value: 1 }).value, 10) || 1;
      var btn = atc; var orig = atcText ? atcText.textContent : '';
      if (atcText) atcText.textContent = 'Wird hinzugefügt …'; if (btn) btn.disabled = true;
      cart.add(current.id, qty).then(function () {
        /* accessory bundle */
        var extras = qsa('[data-ln-acc-check]:checked', root).map(function (c) { return parseInt(c.value, 10); }).filter(function (v, i, a) { return a.indexOf(v) === i; });
        var chain = Promise.resolve();
        extras.forEach(function (id) { chain = chain.then(function () { return cart.add(id, 1); }); });
        return chain;
      }).then(function () { return cart.refresh(); }).then(function () {
        if (atcText) atcText.textContent = orig; if (btn) btn.disabled = false; cart.open();
      }).catch(function (err) { if (atcText) atcText.textContent = orig; if (btn) btn.disabled = false; alert(err.message || 'Konnte nicht hinzugefügt werden.'); });
    });
    if (stickyAtc) stickyAtc.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    /* qty +/- in buy box */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-ln-qtybtn]'); if (!q) return;
      var inp = qs('input[name="quantity"]', root); if (!inp) return;
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.getAttribute('data-ln-qtybtn'), 10));
    });
    init();
  });

  /* accessory "Hinzufügen" buttons */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ln-acc-btn]'); if (!b || b.disabled) return;
    var val = b.getAttribute('data-ln-acc-value');
    var root = b.closest('[data-ln-product]');
    var mainAtc = root && qs('[data-ln-atc]', root);
    if (mainAtc && mainAtc.disabled) { /* Hauptprodukt nicht bestellbar -> Zubehör direkt in den Warenkorb */
      b.disabled = true; cart.add(parseInt(val, 10), 1).then(function () { return cart.refresh(); }).then(function () { b.disabled = false; cart.open(); }).catch(function (err) { b.disabled = false; alert(err.message); });
      return;
    }
    var on = !b.closest('[data-ln-acc-item]').classList.contains('is-selected');
    qsa('[data-ln-acc-check][value="' + val + '"]').forEach(function (c) { c.checked = on; });
    qsa('[data-ln-acc-btn][data-ln-acc-value="' + val + '"]').forEach(function (x) { x.closest('[data-ln-acc-item]').classList.toggle('is-selected', on); qs('span', x).textContent = on ? 'Hinzugefügt ✓' : 'Hinzufügen'; });
  });
  /* accessory checkboxes: sync bundle <-> offcanvas by value */
  d.addEventListener('change', function (e) {
    if (!e.target.matches('[data-ln-acc-check]')) return;
    qsa('[data-ln-acc-check][value="' + e.target.value + '"]').forEach(function (c) { c.checked = e.target.checked; });
  });
  /* ---------- Gallery ---------- */
  function galleryGo(g, idx) {
    var track = qs('.ln-gallery__track', g); var slides = qsa('.ln-gallery__slide', g).filter(function (s) { return s.offsetParent !== null; }); if (!track || idx < 0 || !slides[idx]) return;
    track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
  }
  qsa('[data-ln-gallery]').forEach(function (g) {
    var track = qs('.ln-gallery__track', g), slides = qsa('.ln-gallery__slide', g);
    var dots = qsa('.ln-gallery__dots button', g), thumbs = qsa('.ln-gallery__thumbs button', g);
    var prev = qs('.ln-gallery__nav--prev', g), next = qs('.ln-gallery__nav--next', g);
    var cur = 0;
    var hidden = function () { return slides.filter(function (s) { return s.classList.contains('ln-gallery__slide--hero') && s.offsetParent === null; }).length; };
    var setActive = function () {
      var h = hidden();
      dots.forEach(function (b, i) { b.classList.toggle('is-active', i === cur + h); });
      thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === cur + h); });
    };
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) { cur = i; setActive(); } }, { passive: true });
    dots.forEach(function (b, i) { b.addEventListener('click', function () { galleryGo(g, i - hidden()); }); });
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { galleryGo(g, i - hidden()); }); });
    if (prev) prev.addEventListener('click', function () { galleryGo(g, Math.max(0, cur - 1)); });
    if (next) next.addEventListener('click', function () { galleryGo(g, Math.min(slides.length - 1 - hidden(), cur + 1)); });
    setActive();
  });

  /* ---------- Sticky ATC bar ---------- */
  var sticky = qs('[data-ln-sticky]');
  if (sticky) {
    var onStick = function () {
      sticky.classList.toggle('is-visible', w.scrollY > 80);
      /* Shopify-Vorschauleiste (nur im Theme-Preview) + mobile Layout-Viewport-Differenz ausgleichen */
      var pb = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe') ? 64 : 0;
      var vv = 0;
      if (w.visualViewport && !(d.activeElement && /INPUT|TEXTAREA/.test(d.activeElement.tagName))) { var diff = w.innerHeight - w.visualViewport.height - w.visualViewport.offsetTop; if (diff > 0 && diff < 160) vv = diff; }
      var b = (pb + vv) + 'px'; if (sticky.style.bottom !== b) sticky.style.bottom = b;
    };
    onStick(); w.addEventListener('scroll', onStick, { passive: true });
    var sn = qs('[data-ln-sticky-notify]', sticky);
    if (sn) sn.addEventListener('click', function () { var n = qs('.ln-notify'); if (!n) return; n.scrollIntoView({ behavior: 'smooth', block: 'center' }); var i = qs('input[type=email]', n); if (i) setTimeout(function () { i.focus(); }, 500); });
  }

  /* ---------- Details hotspots ---------- */
  qsa('[data-ln-details]').forEach(function (box) {
    var img = qs('[data-ln-details-img]', box);
    qsa('details', box).forEach(function (dt) {
      dt.addEventListener('toggle', function () {
        if (!dt.open) return;
        qsa('details', box).forEach(function (o) { if (o !== dt) o.open = false; });
        var src = dt.getAttribute('data-image'); if (img && src) { img.src = src; }
      });
    });
  });

  /* ---------- Collection filters (native Shopify filters via GET) ---------- */
  var filterForm = qs('[data-ln-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) { if (e.target.matches('input[type=checkbox],input[type=radio]')) filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit(); });
  }
  var sortSel = qs('[data-ln-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { var u = new URL(w.location.href); u.searchParams.set('sort_by', sortSel.value); w.location.href = u.toString(); });

  /* ---------- Newsletter forms (ajax-less, just state) ---------- */
  qsa('[data-ln-totop]').forEach(function (b) { b.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: 'smooth' }); }); });

  /* ---------- Video autoplay when visible ---------- */
  if ('IntersectionObserver' in w) {
    var vio = new IntersectionObserver(function (ens) { ens.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }); }, { threshold: .25 });
    qsa('video[data-ln-autoplay]').forEach(function (v) { vio.observe(v); });
  }
})();

/* Hover-Bilder der Produktkarten nur auf Hover-Geraeten laden (spart Mobil-Bandbreite) */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:hover)').matches) return;
  var load = function () { Array.prototype.slice.call(document.querySelectorAll('img.is-hover[data-srcset]')).forEach(function (im) { im.srcset = im.getAttribute('data-srcset'); im.sizes = im.getAttribute('data-sizes') || ''; im.removeAttribute('data-srcset'); }); };
  if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2000 }); else setTimeout(load, 800);
})();

/* Warenkorb-Breite: Griff am linken Rand zum Ziehen, Wert bleibt im Browser (localStorage 'ln-cart-w').
   Doppelklick oder Pos1 setzt auf den Standard zurueck, Pfeiltasten aendern in Schritten. */
(function () {
  var KEY = 'ln-cart-w', MIN = 360;
  var cart = document.getElementById('ln-cart');
  if (!cart) return;
  var root = document.documentElement;
  var maxW = function () { return Math.min(window.innerWidth - 96, 1200); };
  var clamp = function (px) { return Math.min(Math.max(px, MIN), maxW()); };
  var apply = function (px) {
    if (px == null) root.style.removeProperty('--ln-cart-w');
    else root.style.setProperty('--ln-cart-w', Math.round(px) + 'px');
  };
  var store = function (px) {
    try { px == null ? localStorage.removeItem(KEY) : localStorage.setItem(KEY, String(Math.round(px))); } catch (e) {}
  };
  var setW = function (px) { px = clamp(px); apply(px); store(px); };
  var reset = function () { store(null); apply(null); };

  var saved = null;
  try { saved = parseFloat(localStorage.getItem(KEY)) || null; } catch (e) {}
  if (saved) apply(clamp(saved));

  var grip = document.createElement('div');
  grip.className = 'ln-off__resize';
  grip.setAttribute('role', 'separator');
  grip.setAttribute('aria-orientation', 'vertical');
  grip.setAttribute('aria-label', 'Breite des Warenkorbs ändern');
  grip.setAttribute('title', 'Ziehen zum Verbreitern · Doppelklick setzt zurück');
  grip.tabIndex = 0;
  cart.appendChild(grip);

  grip.addEventListener('pointerdown', function (e) {
    if (e.button) return;
    e.preventDefault();
    try { grip.setPointerCapture(e.pointerId); } catch (er) {}
    document.body.classList.add('ln-resizing');
    var move = function (ev) { setW(window.innerWidth - ev.clientX); };
    var up = function () {
      document.body.classList.remove('ln-resizing');
      grip.removeEventListener('pointermove', move);
      grip.removeEventListener('pointerup', up);
      grip.removeEventListener('pointercancel', up);
    };
    grip.addEventListener('pointermove', move);
    grip.addEventListener('pointerup', up);
    grip.addEventListener('pointercancel', up);
  });
  grip.addEventListener('dblclick', function (e) { e.preventDefault(); reset(); });
  grip.addEventListener('keydown', function (e) {
    var step = e.shiftKey ? 48 : 16, cur = cart.getBoundingClientRect().width;
    if (e.key === 'ArrowLeft') { e.preventDefault(); setW(cur + step); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); setW(cur - step); }
    else if (e.key === 'Home') { e.preventDefault(); reset(); }
  });
  window.addEventListener('resize', function () {
    var cur = parseFloat(root.style.getPropertyValue('--ln-cart-w'));
    if (cur) apply(clamp(cur));
  });
})();
